export default __webpack_public_path__ + "static/media/shareholder.8ed6c359.svg";